import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../libs'
import { Income } from './types'

export const incomeByMonthListMounted = createEvent()

export const getIncomeByMonth = fx<void, Income[]>({
  method: 'GET',
  url: `/transaction_request/kpi_by_month`,
})

export const $incomeByMonth = restore<Income[]>(
  getIncomeByMonth.doneData.map((a) => a.body),
  [],
)

sample({
  // @ts-ignore
  clock: incomeByMonthListMounted,
  fn: () => {},
  target: getIncomeByMonth,
})
